import { cn } from "@/lib/utils";
import type { ComponentPropsWithoutRef, ReactNode } from "react";

interface SectionProps extends ComponentPropsWithoutRef<"section"> {
	children: ReactNode;
	containerClassName?: string;
	withContainer?: boolean;
}

export function Section({
	children,
	className,
	containerClassName,
	withContainer = true,
	...props
}: SectionProps) {
	return (
		<section
			className={cn("relative scroll-mt-24 py-14 sm:py-16 lg:py-20", className)}
			{...props}
		>
			{withContainer ? (
				<div
					className={cn(
						"mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8",
						containerClassName,
					)}
				>
					{children}
				</div>
			) : (
				children
			)}
		</section>
	);
}
